import * as Mod1 from "./discourse/connectors/user-preferences-notifications/solutions-notification-preferences-container.gjs";
import * as Mod2 from "./discourse/initializers/extend-for-solved-reminders";
const compatModules = {
  "discourse/connectors/user-preferences-notifications/solutions-notification-preferences-container": Mod1,
  "discourse/initializers/extend-for-solved-reminders": Mod2,
};
export { compatModules };
export default compatModules;
